// Correctif Crafty : stabilisation mobile + recalcul Swiper
(function() {
    function reinitCraftySwiper() {
        const carousels = document.querySelectorAll('.etooCarousel');

        if (!carousels.length) return;

        carousels.forEach(carousel => {
            // Swiper instance déjà existante ?
            const swiperInstance = carousel.swiper;

            if (swiperInstance) {
                swiperInstance.update();       // recalcul des tailles
                swiperInstance.updateSlides(); // recalcul des slides
                swiperInstance.updateProgress();
                swiperInstance.updateSlidesClasses();
            }
        });
    }

    // 1) Recalcul après chargement complet de la page
    window.addEventListener('load', () => {
        setTimeout(reinitCraftySwiper, 150);
        setTimeout(reinitCraftySwiper, 400);
    });

    // 2) Recalcul après redimensionnement (mobile orientation, zoom, etc.)
    window.addEventListener('resize', () => {
        setTimeout(reinitCraftySwiper, 150);
    });

    // 3) Recalcul après lazy‑loading des images
    document.addEventListener('DOMContentLoaded', () => {
        const imgs = document.querySelectorAll('.etooCarousel img');
        imgs.forEach(img => {
            img.addEventListener('load', () => {
                setTimeout(reinitCraftySwiper, 100);
            });
        });
    });
})();
